
<div [id]="selectId" class="ts-ext-cnt ext-cnt-small" [ngClass]="{'no-margin-top': !spaceLabel, 'no-min-width' : noMinWidth}">
    <span *ngIf="labelText != ''" class="ts-label">{{labelText}} <span *ngIf="isRequired">*</span></span>
    <div *ngIf="labelText == '' && spaceLabel" style="height: 1.7vh; width:100%"></div>
    <!-- [id]="optionId" -->
    <div class="input-wrapper" #inputWrapper>
        <input [type]="'text'" class="ti-input ti-input-small mr-5 {{selectId}}"  
        [placeholder]="getPlaceHolder()" [ngClass]="{'input-disabled-light' : !isOpen}"
        [value]="value" (input)="onInputChange($event)" (keydown)="onKeyDown($event)" [readonly]="isOpen == false && value == ''" (click)="onOpenClose($event)">

        <div *ngIf="filteredValues && filteredValues.length > 0" class="ts-ico-cnt">
            <i *ngIf="!isOpen" class="fal fa-angle-down ts-ico" (click)="onOpenClose($event)"></i>
            <i *ngIf="isOpen" class="fal fa-angle-up ts-ico" (click)="onOpenClose($event)"></i>
        </div>

        <div *ngIf="!filteredValues || filteredValues.length == 0" class="ts-ico-cnt ts-ico-cnt-disabled">
            <i *ngIf="!isOpen && (!filteredValues || filteredValues.length == 0)" class="fal fa-angle-down ts-ico"></i>
        </div>
    </div>
    <div [id]="optionId" *ngIf="isOpen" class="ts-options-cnt" [style.top.px]="optTop" [style.left.px]="optLeft" [style.width.px]="dropdownWidth" (keydown)="onKeyDown($event)">
        <div class="ts-opt-int">
            <div class="opt-row">
                <input type="checkbox" class="tso-chk" style="margin-right: 1vw" (click)="onSelectAll($event)" [checked]="(selectedValues.length == filteredValues.length)">
                <span style="font-weight: 700;cursor: pointer;" (click)="onSelectAll($event)">({{'grid.selectAll' | translate}})</span>
            </div>
            <div *ngFor="let item of filteredValues" class="opt-row">
                <input type="checkbox" class="tso-chk" style="margin-right: 1vw" (click)="onSelectDeselect(item)" [checked]="imChecked(item)">
                <span style="cursor: pointer;" class="tso-value" (click)="onSelectDeselect(item)">{{item}}</span>
            </div>
        </div>
        <div class="opt-btn-cnt">
            <!-- <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)" style="width: 100%;"></teiasoft-toolbar> -->
             <button class="teia-button-small tb-primary tso-button mr-5" (click)="onOkClick()" [disabled]="!this.selectedValues || this.selectedValues.length == 0">{{'toolbar.ok' | translate}}</button>
             <button class="teia-button-small tb-cancel tso-button" (click)="onCancelClick()">{{'toolbar.cancel' | translate}}</button>
        </div>
    </div>
</div>